import type { IconProps } from './index';
import type { ReactElement } from 'react';

import { useTheme } from 'styled-components';

import { Svg } from './styles';

const PhosphorCheckIcon = ({ className, color, hoverColor }: IconProps): ReactElement => {
  const theme = useTheme();

  return (
    <Svg
      className={className}
      viewBox="0 0 16 16"
      $hoverColor={hoverColor}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill={color || theme.colors.content.primary}>
        <path d="m14.53 5.03-8 8a.75.75 0 0 1-1.06 0l-3.5-3.5a.75.75 0 1 1 1.06-1.06L6 11.44l7.47-7.47a.75.75 0 0 1 1.06 1.06Z" />{' '}
      </g>
    </Svg>
  );
};

export default PhosphorCheckIcon;
